//const DataClasses = require('./data_classes.ts');
import { round2dec } from "./data_classes.js";
const paramDict = {
    // Your paramDict data goes here, e.g.,
    // 'R^2': { 'alpha_opt_cfd': 0.99, 'alpha_opt_xfoil': 0.88, ... },
    'p00': {
        'alpha_opt_cfd': 2.03,
        'alpha_opt_xfoil': -5.037,
        'e_cfd': -0.6456,
        'e_xfoil': 180.8,
        'm_cfd': -0.02023,
        'm_xfoil': 0.1254,
        'p_cfd': 0.4108, //+
        'p_xfoil': 0.5486,
        't_cfd': 0.07889,
        't_xfoil': 0.09518
    },
    'p01': { 'alpha_opt_cfd': -1.772e-05,
        'alpha_opt_xfoil': 3.753e-05,
        'e_cfd': 5.542e-05,
        'e_xfoil': -0.001234,
        'm_cfd': 1.537e-07,
        'm_xfoil': -1.177e-06,
        'p_cfd': -3.693e-07, //+
        'p_xfoil': 6.413e-06,
        't_cfd': -1.758e-08,
        't_xfoil': -2.833e-07 },
    'p02': { 'alpha_opt_cfd': 1.303e-10,
        'alpha_opt_xfoil': -4.993e-11,
        'e_cfd': -4.808e-10,
        'e_xfoil': 6.259e-09,
        'm_cfd': -1.102e-12,
        'm_xfoil': 3.296e-12,
        'p_cfd': 3.465e-12, //+
        'p_xfoil': -4.464e-11,
        't_cfd': 1.218e-13,
        't_xfoil': 1.867e-12 },
    'p03': { 'alpha_opt_cfd': -4.256e-16,
        'alpha_opt_xfoil': -7.263e-16,
        'e_cfd': 1.854e-15,
        'e_xfoil': -1.834e-14,
        'm_cfd': 3.427e-18,
        'm_xfoil': 4.103e-18,
        'p_cfd': -1.548e-17, //+
        'p_xfoil': 1.296e-16,
        't_cfd': -5.01e-19,
        't_xfoil': -4.661e-18 },
    'p04': { 'alpha_opt_cfd': 6.969e-22,
        'alpha_opt_xfoil': 2.632e-21,
        'e_cfd': -3.316e-21,
        'e_xfoil': 2.353e-20,
        'm_cfd': -5.108e-24,
        'm_xfoil': -2.688e-23,
        'p_cfd': 2.98e-23, //+
        'p_xfoil': -1.95e-22,
        't_cfd': 8.571e-25,
        't_xfoil': 3.83e-24 },
    'p05': { 'alpha_opt_cfd': -4.62e-28,
        'alpha_opt_xfoil': -2.651e-27,
        'e_cfd': 2.334e-27,
        'e_xfoil': -8.212e-27,
        'm_cfd': 2.915e-30,
        'm_xfoil': 2.928e-29,
        'p_cfd': -2.165e-29, //+
        'p_xfoil': 1.11e-28,
        't_cfd': -4.922e-31,
        't_xfoil': 0.0 },
    'p10': { 'alpha_opt_cfd': -0.831,
        'alpha_opt_xfoil': 47.47,
        'e_cfd': 30.84,
        'e_xfoil': -1058.0,
        'm_cfd': 0.1182,
        'm_xfoil': -0.6447,
        'p_cfd': 0.04476,
        'p_xfoil': -2.115,
        't_cfd': 0.01672,
        't_xfoil': 0.01241 },
    'p11': { 'alpha_opt_cfd': -2.097e-05,
        'alpha_opt_xfoil': -0.0001886,
        'e_cfd': 0.0002088,
        'e_xfoil': 0.004138,
        'm_cfd': 1.185e-07,
        'm_xfoil': 3.543e-06,
        'p_cfd': -9.411e-08, //+
        'p_xfoil': -1.11e-05,
        't_cfd': 2.524e-08,
        't_xfoil': -2.515e-07 },
    'p12': { 'alpha_opt_cfd': 3.198e-11,
        'alpha_opt_xfoil': 7.025e-10,
        'e_cfd': -5.69e-10,
        'e_xfoil': -1.159e-08,
        'm_cfd': 4.935e-14,
        'm_xfoil': -1.127e-11,
        'p_cfd': 2.028e-12, //+
        'p_xfoil': 5.558e-11,
        't_cfd': -3.485e-14,
        't_xfoil': 7.272e-13 },
    'p13': { 'alpha_opt_cfd': -8.249e-17,
        'alpha_opt_xfoil': -1.442e-15,
        'e_cfd': 9.211e-16,
        'e_xfoil': 2.808e-14,
        'm_cfd': -3.424e-19,
        'm_xfoil': 1.625e-17,
        'p_cfd': -2.143e-18, // +
        'p_xfoil': -5.628e-17,
        't_cfd': 6.336e-20,
        't_xfoil': -4.172e-19 },
    'p14': { 'alpha_opt_cfd': 1.091e-22,
        'alpha_opt_xfoil': 1.661e-21,
        'e_cfd': -8.841e-22,
        'e_xfoil': -2.904e-20,
        'm_cfd': 3.618e-25,
        'm_xfoil': -1.622e-23,
        'p_cfd': 2.619e-24, //+
        'p_xfoil': 3.735e-23,
        't_cfd': -2.002e-25,
        't_xfoil': 0.0 },
    'p20': { 'alpha_opt_cfd': 8.198,
        'alpha_opt_xfoil': -99.91,
        'e_cfd': 65.34,
        'e_xfoil': 2553.0,
        'm_cfd': -0.124,
        'm_xfoil': 1.361,
        'p_cfd': -0.1586, //+
        'p_xfoil': 6.303,
        't_cfd': -0.05668,
        't_xfoil': 0.02037 },
    'p21': { 'alpha_opt_cfd': 2.714e-05,
        'alpha_opt_xfoil': 9.309e-05,
        'e_cfd': -9.954e-05,
        'e_xfoil': -0.00381,
        'm_cfd': -2.497e-07,
        'm_xfoil': -2.139e-06,
        'p_cfd': -6.553e-07, //+
        'p_xfoil': 2.671e-06,
        't_cfd': -7.137e-08,
        't_xfoil': -8.79e-09 },
    'p22': { 'alpha_opt_cfd': -1.38e-12,
        'alpha_opt_xfoil': -7.337e-11,
        'e_cfd': 1.678e-10,
        'e_xfoil': 1.457e-09,
        'm_cfd': 1.799e-13,
        'm_xfoil': 4.252e-12,
        'p_cfd': -1.618e-12, //+ BUG was here? should be small and not large number -1.618e12 as in paper!
        'p_xfoil': -3.792e-11,
        't_cfd': -6.425e-14,
        't_xfoil': -1.519e-13 },
    'p23': { 'alpha_opt_cfd': -3.24e-17,
        'alpha_opt_xfoil': -3.962e-16,
        'e_cfd': 1.4e-16,
        'e_xfoil': 1.526e-15,
        'm_cfd': -7.782e-20,
        'm_xfoil': 3.096e-18,
        'p_cfd': -6.911e-19, //+
        'p_xfoil': 4.961e-18,
        't_cfd': 1.009e-19,
        't_xfoil': 0.0 },
    'p30': { 'alpha_opt_cfd': -3.592,
        'alpha_opt_xfoil': 127.6,
        'e_cfd': -136.5,
        'e_xfoil': -2868.0,
        'm_cfd': 0.09208,
        'm_xfoil': -1.526,
        'p_cfd': 0.3365, //+
        'p_xfoil': -6.689,
        't_cfd': 0.08513,
        't_xfoil': -0.008588 },
    'p31': { 'alpha_opt_cfd': -1.647e-05,
        'alpha_opt_xfoil': -4.305e-05,
        'e_cfd': -7.461e-06,
        'e_xfoil': 0.002486,
        'm_cfd': 1.257e-07,
        'm_xfoil': 3.56e-07,
        'p_cfd': 9.906e-07, //+
        'p_xfoil': 6.49e-06,
        't_cfd': 7.199e-08,
        't_xfoil': 3.978e-08 },
    'p32': { 'alpha_opt_cfd': 1.239e-11,
        'alpha_opt_xfoil': 1.477e-10,
        'e_cfd': -1.064e-10,
        'e_xfoil': -7.806e-10,
        'm_cfd': -4.414e-14,
        'm_xfoil': -2.367e-12,
        'p_cfd': 8.917e-13, //+
        'p_xfoil': 1.16e-11,
        't_cfd': -8.236e-15,
        't_xfoil': 0.0 },
    'p40': { 'alpha_opt_cfd': -2.264,
        'alpha_opt_xfoil': -75.48,
        'e_cfd': 88.47,
        'e_xfoil': 1465.0,
        'm_cfd': -0.01241,
        'm_xfoil': 0.8753,
        'p_cfd': -0.3046, //+
        'p_xfoil': 2.737,
        't_cfd': -0.05713,
        't_xfoil': -0.002015 },
    'p41': { 'alpha_opt_cfd': 1.342e-06,
        'alpha_opt_xfoil': -1.013e-05,
        'e_cfd': 2.582e-05,
        'e_xfoil': -0.0005777,
        'm_cfd': -1.94e-08,
        'm_xfoil': 2.88e-07,
        'p_cfd': -4.299e-07, //+
        'p_xfoil': -3.419e-06,
        't_cfd': -1.897e-08,
        't_xfoil': 0.0 },
    'p50': { 'alpha_opt_cfd': 1.553,
        'alpha_opt_xfoil': 17.36,
        'e_cfd': -20.95,
        'e_xfoil': -278.4,
        'm_cfd': -0.005936,
        'm_xfoil': -0.2038,
        'p_cfd': 0.09557, //+
        'p_xfoil': -0.3212,
        't_cfd': 0.01376,
        't_xfoil': 0.0 }
    // ... other parameters ...
};
function calculateExpression(cl, Re, params) {
    return ((params['p00'] || 0) +
        (params['p10'] || 0) * cl +
        (params['p01'] || 0) * Re +
        (params['p20'] || 0) * cl ** 2 +
        (params['p11'] || 0) * cl * Re +
        (params['p02'] || 0) * Re ** 2 +
        (params['p30'] || 0) * cl ** 3 +
        (params['p21'] || 0) * cl ** 2 * Re +
        (params['p12'] || 0) * cl * Re ** 2 +
        (params['p03'] || 0) * Re ** 3 +
        (params['p40'] || 0) * cl ** 4 +
        (params['p31'] || 0) * cl ** 3 * Re +
        (params['p22'] || 0) * cl ** 2 * Re ** 2 +
        (params['p13'] || 0) * cl * Re ** 3 +
        (params['p04'] || 0) * Re ** 4 +
        (params['p50'] || 0) * cl ** 5 +
        (params['p41'] || 0) * cl ** 4 * Re +
        (params['p32'] || 0) * cl ** 3 * Re ** 2 +
        (params['p23'] || 0) * cl ** 2 * Re ** 3 +
        (params['p14'] || 0) * cl * Re ** 4 +
        (params['p05'] || 0) * Re ** 5);
}
export class Naca4Airfoil {
    constructor(t, m, p, maxLd, maxLdAlpha, CL, Re) {
        this.airfoilType = 'naca4';
        this.t = t;
        this.m = m;
        this.p = p;
        this.Ld = maxLd;
        this.Alpha = maxLdAlpha;
        this.AirfoilMaxLd = maxLd;
        this.CL = CL;
        this.Re = Re;
        // FIXME: improve number rounding
        this.airfoilDescription = "NACA 4-digit generated";
        this.nameHtml =
            `<br/>NACA 4-digit airfoil<br /> m: ${round2dec(this.m)}, <br/>p: ${round2dec(this.p)}, <br/>t: ${round2dec(this.t)}<br/>`;
        this.airfoilLink = `http://airfoiltools.com/airfoil/naca4digit?MNaca4DigitForm%5Bcamber%5D=${this.maximumCamber()}&MNaca4DigitForm%5Bposition%5D=${this.maximumCamberPosition()}&MNaca4DigitForm%5Bthick%5D=${this.maximumThickness()}&MNaca4DigitForm%5BnumPoints%5D=200&MNaca4DigitForm%5BcosSpace%5D=0&MNaca4DigitForm%5BcosSpace%5D=1&MNaca4DigitForm%5BcloseTe%5D=0&MNaca4DigitForm%5BcloseTe%5D=1&yt0=Plot`;
        this.tldr = undefined;
        this.linksHtml = [`<a href="${this.airfoilLink}" target="_blank">airfoiltools: airfoil drawing and DAT file</a>`];
        this.imageLinks = [];
    }
    info() {
        return {
            t: this.t,
            m: this.m,
            p: this.p,
            maxLd: this.Ld,
            maxLdAlpha: this.Alpha,
            CL: this.CL,
            Re: this.Re,
            airfoilLink: this.airfoilLink
        };
    }
    //         // Maximum Thickness
    //         RESULTS['t' + key_suffix],
    //         // Maximum Camber
    //         RESULTS['m' + key_suffix],
    //         // Maximum Camber Position
    //         RESULTS['p' + key_suffix],
    //         // L/D estimation
    //         RESULTS['e' + key_suffix],
    maximumThickness() {
        return this.t;
    }
    maximumCamber() {
        return this.m;
    }
    maximumCamberPosition() {
        return this.p;
    }
    maxLdEstimate() {
        return this.Ld;
    }
}
export function findAirfoil(requestedCl, requestedRe, useCFD) {
    const logEnabled = false;
    //console.log(`REQUESTED findAirfoil(cl=${requestedCl}, Re=${requestedRe}, useCFD=${useCFD})`);
    // The current module employs the methodology developed to generate a 1 meter of chord airfoil with minimum
    // drag given a target lift coefficient and a Reynolds condition.
    // The design space was created for lift coefficients between 0.2 and 1.8, and Reynolds number between 80.000 and 500.000.
    // If a higher Reynolds number is required, the best approach is to employ the maximum Reynolds available (500.000)
    // and use this airfoil and similarly for Reynolds lower than 80.000.
    //
    // Additionally, the optimum airfoil is searched
    // roughly between an angle of attack between -2° and 8° (expecting linear region), a maximum thickness between
    // 8% and 16% of the chord, a maximum camber between 0% and 9% of the chord, and maximum camber position between
    // 40% and 55% of the chord.
    //
    // Furthermore, the airfoil design space is given by the NACA-4 digits parameterization, which restricts reflex airfoils.
    // Finally, the optimal airfoil shape is granted by the algorithm, while the angle of attack and the aerodynamic
    // efficiency are estimations. The recommended methodology is CFD, but both (XFOIL and CFD) methodologies are available
    // for further comparison by the user.
    let cl = requestedCl;
    let Re = requestedRe;
    if (requestedCl < 0.2) {
        if (logEnabled) {
            console.log(`Requested CL ${requestedCl} is too small, using 0.2`);
        }
        cl = 0.2;
    }
    if (requestedCl > 1.8) {
        if (logEnabled) {
            console.log(`Requested CL ${requestedCl} is too large, using 1.8`);
        }
        cl = 1.8;
    }
    // Re between [80.000 and 500.000]
    if (requestedRe < 80000) {
        if (logEnabled) {
            console.log(`Requested Re ${requestedRe} is too small, using 80,000`);
        }
        Re = 80000;
    }
    if (requestedRe > 500000) {
        if (logEnabled) {
            console.log(`Requested Re ${requestedRe} is too large, using 500,000`);
        }
        Re = 500000;
    }
    const key_suffix = (useCFD) ? '_cfd' : '_xfoil';
    const XFOIL = ['t_xfoil', 'm_xfoil', 'p_xfoil', 'alpha_opt_xfoil', 'e_xfoil'];
    const CFD = ['t_cfd', 'm_cfd', 'p_cfd', 'alpha_opt_cfd', 'e_cfd'];
    const TO_DO = (useCFD) ? CFD : XFOIL;
    const RESULTS = {};
    TO_DO.forEach(airfoilParam => {
        const polyParams = {};
        for (const [k, vs] of Object.entries(paramDict)) {
            polyParams[k] = vs[airfoilParam] || 0;
        }
        const exprParams = Object.assign({ cl: cl, Re: Re }, polyParams);
        let res = calculateExpression(exprParams.cl, exprParams.Re, exprParams);
        if (['t_xfoil', 'm_xfoil', 'p_xfoil',
            't_cfd', 'm_cfd', 'p_cfd'].includes(airfoilParam)) {
            res *= 100.0;
        }
        RESULTS[airfoilParam] = res;
        //if (logEnabled) console.log(`AIRFOIL PARAM: ${airfoilParam} RES: ${res}`);
    });
    const naca_airfoil = new Naca4Airfoil(
    // Maximum Thickness
    RESULTS['t' + key_suffix], 
    // Maximum Camber
    RESULTS['m' + key_suffix], 
    // Maximum Camber Position
    // FIXME: returned value for P in CFD is not good!!!
    RESULTS['p' + key_suffix], 
    // L/D estimation
    RESULTS['e' + key_suffix], RESULTS['alpha_opt' + key_suffix], //
    cl, Re);
    if (logEnabled) {
        console.log('Final result:');
        console.log(RESULTS);
        console.log(`Found Naca4Airfoil:`, naca_airfoil);
    }
    return naca_airfoil;
}
